// All needed imports
import { SelectModel } from '../../core/models/select.model';
import { RadioCardListModel } from 'src/app/core/models/radio-card-list.model';
import { RadioCardModel } from '../../core/models/radio-card.model';
import { InputModel } from '../../core//models/input.model';
import { Numbers, commondSelectOptionsList } from 'src/app/utils/constants';
import { formConfigCommond } from 'src/app/utils/form.utils';
import { setDateFormConfig } from 'src/app/utils/form-utils-extended';
import { CalendarBaseModel } from 'src/app/core/models/calendar-base.model';
import { setBtnTooltip, setRadioCardModel, setSelectModel, setSelectOptions, setSelectValue } from 'src/app/utils/labels.utils';

// set the LITERAL_TEXT value with the form1 value
// The value is individualTravelAsistance
const LITERAL_TEXT = 'individualTravelAsistance';
const DATE = new CalendarBaseModel(setDateFormConfig(LITERAL_TEXT));

// ParticularData object
const PARTICULAR_DATA = {
  numberOfInsured: new SelectModel(
    setSelectModel([LITERAL_TEXT, 'numberOfInsured'],
      setSelectValue('form1.number-insured', 'form1.number-insured.error', 'label_size_7'),
      setSelectOptions('', '', [{ name: '0', id: Numbers.number0 },
      { name: '1', id: Numbers.number1 }, { name: '2', id: Numbers.number2 },
      { name: '3', id: Numbers.number3 }])
    )
  ),
  guaranteeLimitOfMedicalExpenses: new SelectModel(
  setSelectModel([LITERAL_TEXT, 'guaranteeLimitOfMedicalExpenses'],
    setSelectValue('form1.limit-guarantee', 'form1.limit-guarantee.error', 'label_size_7'),
    setSelectOptions('', '', [])
    )
  ),
  // By default, its value is Spain.
  countryOrigin: new InputModel({
    linkFormPath: [LITERAL_TEXT, 'countryOrigin'],
    label: 'form1.country-origin',
    value: 'España',
    required: true,
    disabled: true,
    requiredText: 'form1.country-origin.error'
  }),
  // By default, its value is Spain.
  countryDestiny: new InputModel({
    linkFormPath: [LITERAL_TEXT, 'countryDestiny'],
    label: 'form1.country-destiny',
    value: 'España',
    required: true,
    disabled: true,
    requiredText: 'form1.country-destiny.error'
  }),
  date: DATE,
  insuranceType: new RadioCardListModel({
    linkFormPath: [LITERAL_TEXT, 'insuranceType'],
    radioCardList: [
      new RadioCardModel(setRadioCardModel(Numbers.number0, 'form1.coverage0'))
    ]
  }),
  petInsureds: new SelectModel(
    setSelectModel([LITERAL_TEXT, 'petInsureds'],
      setSelectValue('form1.petInsureds', 'form1.petInsureds.error', 'label_size_7'),
      setSelectOptions('', '', [{ name: '1', id: Numbers.number1 }, { name: '2', id: Numbers.number2 },
        { name: '3', id: Numbers.number3 }]),
      setBtnTooltip('icon icon-info', 'form1.petInsureds-tooltip')
    )
  )
};

// Export the obj to be used in the angular components app
export const FORM_CONFIG = {
  ...formConfigCommond(LITERAL_TEXT, Numbers.number6),
  ...PARTICULAR_DATA
};
